import { Button, Group, Modal} from "@veneer/core";
import { useEffect, useState } from "react";
import {Container,  } from "react-bootstrap";
import "./submitpopup.css"
import { t } from "i18next";
export const OnSubmitModal = (props: any) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  
  useEffect(() => {
    setIsOpen(props.openState);
  }, [props.openState]);
  return (
    <>
      <Modal
        align="start"
        closeButton
        className="select-feedback-modal"
        show={isOpen}
        onClose={() => {
          localStorage.removeItem("isPopup");
          setIsOpen(false);
        }}
        header={
          <div style={{ display: "flex"}} className="mm">
            <img
              src="https://logos-world.net/wp-content/uploads/2020/11/HP-Logo.png"
              alt=""
              style={{ height: "46px", width: "auto" }}
            />
            <h3><span dangerouslySetInnerHTML={{ __html: (window as any).feedbackHeader}}></span></h3>
          </div>
        }
        footer={
          <Group className="d-flex justify-content-end w-100">
            <Button 
              appearance="primary"
              onClick={()=> {
                localStorage.removeItem("isPopup");
                setIsOpen(false)
              }}
            >
             OK
            </Button>
          </Group>
        }
      >
        <Container className="mm" >
        <span dangerouslySetInnerHTML={{ __html: (window as any).feedbackMessage}}></span>
            
        </Container>
 
        
      </Modal>
    </>
  );
};
